import { FC, useState } from 'react';
import styled from 'styled-components';
import { Button, Group, Modal, ResponsivePadding } from '../../components';
import { AgreementModal } from '../../components/HellosignModal';
import { ReviewFormValues } from '../../pages/review/ReviewPage.types';

const LinkButton = styled.a`
  text-decoration: none;
  color: #009bf2;
  cursor: pointer;
`;

const AgreementNotice = styled.p`
  && {
    font-size: 12px;
    color: ${props => props.theme.colors.core.gray[400].hex};
  }
`;

interface ReviewAgreementModalsProps {
  formValues: ReviewFormValues;
}

export const creditInquiryModalContent = `You understand that by clicking on the checkbox associated with this notice, you are providing ‘written instructions’ to Stax and any lender to whom Stax forwards this application, in connection with this application, for commercial lending under the Fair Credit Reporting Act, hereby authorizing Stax and any such lender to obtain information from your personal credit report or other information from Experian. You authorize Stax and any such lender to obtain such information solely in connection with this application for commercial lending.`;

export const ReviewAgreementModals: FC<ReviewAgreementModalsProps> = props => {
  const [isPayfacAgreementModalOpen, setIsPayfacAgreementModalOpen] =
    useState(false);
  const [
    isCreditInquiryAgreementModalOpen,
    setIsCreditInquiryAgreementModalOpen,
  ] = useState(false);

  return (
    <>
      <AgreementNotice>
        By submitting your merchant application, you agree to the{' '}
        <LinkButton
          id="payfac-agreement-link"
          data-testid="payfac-agreement-link"
          onClick={e => {
            e.stopPropagation();
            setIsPayfacAgreementModalOpen(true);
          }}
        >
          <span>Sub-Merchant Agreement,</span>
        </LinkButton>{' '}
        and certify that all information you have provided is complete and
        correct.
        You further agree to provide written authorization to undergo a credit
        check as part of the{' '}
        <LinkButton
          id="credit-inquiry-agreement-link"
          data-testid="credit-inquiry-agreement-link"
          onClick={e => {
            e.stopPropagation();
            setIsCreditInquiryAgreementModalOpen(true);
          }}
        >
          <span>FCRA Permissible Purpose Guidelines</span>
        </LinkButton>
        .
      </AgreementNotice>

      <AgreementModal
        formValues={props.formValues}
        isOpen={isPayfacAgreementModalOpen}
        onClose={() => setIsPayfacAgreementModalOpen(false)}
      />
      <Modal
        title="FCRA Permissible Purpose Guidelines"
        isOpen={isCreditInquiryAgreementModalOpen}
        onClose={() => setIsCreditInquiryAgreementModalOpen(false)}
      >
        <ResponsivePadding desktop="1rem" mobile="1rem">
          {creditInquiryModalContent}

          <Group justify="end">
            <Button onClick={() => setIsCreditInquiryAgreementModalOpen(false)}>
              <span>Close</span>
            </Button>
          </Group>
        </ResponsivePadding>
      </Modal>
    </>
  );
};
